// @flow
import { PRODUCT_IMMERSIVE } from 'Client/cms/toolkit/constants';
import { ProductImmersiveLine } from 'Components/lines/product-immersive-line/ProductImmersiveLine.jsx';
import { productImmersiveResolver } from './productImmersive.resolver';

export const productImmersiveDescriptor = {
  name: PRODUCT_IMMERSIVE,
  component: ProductImmersiveLine,
  resolve: productImmersiveResolver.resolve,
};
